isGiftIconCTAEnabled